import type { RefObject } from 'react';

//Helpful React snippet for scrolling to top of a "ref"
export const scrollToRef = (
	ref: RefObject<HTMLElement>,
	behaviorType: ScrollBehavior = 'smooth',
) => {
	ref?.current?.scrollIntoView({
		block: 'start',
		behavior: behaviorType,
	});
};
